import React, { useEffect, useState, useRef } from "react"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Badge,
    Input,
    Form
} from "reactstrap"
import { connect } from "react-redux"
import { Link, useParams } from "react-router-dom"
import moment from "moment"

//Import Actions
import {
    getTicketDetail,
    replySupportTicketAction,
    setBreadcrumbItems
} from "../../store/actions"

const SupportTicketDetail = props => {
    const { id } = useParams()
    const [message, setMessage] = useState("")
    const scrollRef = useRef(null)

    document.title = "Détail Ticket Support | CRM Entreprise"

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Support", link: "/support/tickets" },
        { title: "Discussion", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Discussion Support", breadcrumbItems)
        props.getTicketDetail(id)
    }, [id])

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: "smooth" })
        }
    }, [props.ticket?.messages])

    const [selectedFiles, setSelectedFiles] = useState([])
    const API_STORAGE_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace('/api', '/storage/');

    const handleSendMessage = (e) => {
        e.preventDefault()
        if (message.trim() || selectedFiles.length > 0) {
            const formData = new FormData()
            formData.append("message", message)
            for (let i = 0; i < selectedFiles.length; i++) {
                formData.append("attachments[]", selectedFiles[i])
            }
            props.replySupportTicketAction(id, formData)
            setMessage("")
            setSelectedFiles([])
        }
    }

    const { ticket } = props

    if (!ticket) return <div className="page-content">Chargement...</div>

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={4}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title mb-4">Informations Ticket</h4>
                                    <div className="table-responsive">
                                        <table className="table table-nowrap mb-0">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Numéro :</th>
                                                    <td>#TK-{ticket.id}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Sujet :</th>
                                                    <td className="text-wrap">{ticket.subject}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Catégorie :</th>
                                                    <td>{ticket.category}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Priorité :</th>
                                                    <td>
                                                        <Badge color={ticket.priority === 'urgent' ? 'danger' : 'info'}>
                                                            {ticket.priority.toUpperCase()}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Statut :</th>
                                                    <td>
                                                        <Badge color={ticket.status === 'open' ? 'success' : 'secondary'}>
                                                            {ticket.status.toUpperCase()}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Assigné à :</th>
                                                    <td>{ticket.assigned_to ? (ticket.assigned_to.first_name + ' ' + ticket.assigned_to.last_name) : 'En attente'}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Créé le :</th>
                                                    <td>{moment(ticket.created_at).format('DD/MM/YYYY HH:mm')}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col lg={8}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title mb-4">Conversation</h4>

                                    <div style={{ height: "450px", overflowY: "auto", padding: "15px", backgroundColor: "#f8f9fa" }} className="rounded mb-4">
                                        {(ticket.messages || []).map((msg, index) => {
                                            const authUser = JSON.parse(localStorage.getItem("authUser"))
                                            const currentUserId = props.currentUser?.user?.id || props.currentUser?.id || authUser?.user?.id || authUser?.id

                                            // Ensure both are compared as same type (string or number)
                                            const isMe = String(msg.user_id) === String(currentUserId)
                                            const isSupport = msg.user?.user_type === 'system'

                                            return (
                                                <div key={index} className={`d-flex mb-4 ${isMe ? 'justify-content-end' : 'justify-content-start'}`}>
                                                    <div className={`p-3 rounded shadow-sm ${isMe ? 'bg-primary text-white' : 'bg-white'}`} style={{ maxWidth: "80%" }}>
                                                        {!isMe && (
                                                            <div className="fw-bold small mb-1">
                                                                {msg.user?.first_name} {isSupport ? '(Support)' : ''}
                                                            </div>
                                                        )}
                                                        <p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>{msg.message}</p>
                                                        {msg.attachments && Array.isArray(msg.attachments) && msg.attachments.length > 0 && (
                                                            <div className="mt-2 pt-2 border-top">
                                                                {msg.attachments.map((file, fKey) => (
                                                                    <div key={fKey} className="d-flex align-items-center mb-1">
                                                                        <i className="mdi mdi-paperclip me-2" style={{ color: isMe ? 'white' : 'inherit' }}></i>
                                                                        <a
                                                                            href={`${API_STORAGE_URL}${file.path}`}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            className={isMe ? "text-white text-decoration-underline" : "text-primary"}
                                                                            style={{ fontSize: '12px' }}
                                                                        >
                                                                            {file.name}
                                                                        </a>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        <div className={`small mt-1 ${isMe ? 'text-white-50' : 'text-muted'}`}>
                                                            {moment(msg.created_at).format('HH:mm')}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div ref={scrollRef} />
                                    </div>

                                    {ticket.status !== 'closed' && (
                                        <Form onSubmit={handleSendMessage}>
                                            <div className="mb-3">
                                                <div className="d-flex">
                                                    <Input
                                                        type="textarea"
                                                        rows="2"
                                                        className="me-2"
                                                        placeholder="Votre message ici..."
                                                        value={message}
                                                        onChange={(e) => setMessage(e.target.value)}
                                                    />
                                                    <Button color="primary" type="submit" className="px-4" disabled={!message.trim() && selectedFiles.length === 0}>
                                                        <i className="mdi mdi-send"></i>
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <label htmlFor="file-upload" className="btn btn-light btn-sm mb-0 me-2">
                                                    <i className="mdi mdi-paperclip me-1"></i> Joindre des fichiers
                                                </label>
                                                <Input
                                                    id="file-upload"
                                                    type="file"
                                                    multiple
                                                    className="d-none"
                                                    onChange={(e) => setSelectedFiles(e.target.files)}
                                                />
                                                {selectedFiles.length > 0 && (
                                                    <small className="text-muted">{selectedFiles.length} fichier(s) prêt(s)</small>
                                                )}
                                            </div>
                                        </Form>
                                    )}
                                    {ticket.status === 'closed' && (
                                        <div className="alert alert-secondary text-center">Ce ticket est fermé.</div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    ticket: state.Tickets.ticket,
    currentUser: state.Login.user
})

export default connect(mapStateToProps, {
    getTicketDetail,
    replySupportTicketAction,
    setBreadcrumbItems
})(SupportTicketDetail)
